import {
  List,
  Datagrid,
  TextField,
  ChipField,
  ArrayField,
  SingleFieldList,
  DateField,
  FunctionField,
  Filter,
  ReferenceInput,
  SelectInput,
  DateInput,
  useListController,
  TextInput,
} from "react-admin";
import { exporter } from "../utils";
import CustomActions from "../../../components/CustomActions";
import { ListPagination } from "../../../utils";
import OptInUserButtons from "./OptInUserButtons/OptInUserButtons";
import typeDocumentChoice from "../../../constants/choices/typeDocumentChoice";

const textStyle = { margin: "15px 0 0 10px" };

const OptinFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput
      sort={{ field: "name", order: "ASC" }}
      perPage={999}
      resource="lab"
      label="Laboratório"
      source="labs.id"
      reference="labs"
      alwaysOn={true}
    >
      <SelectInput label="Laboratório" optionText="name" optionValue="id" />
    </ReferenceInput>
    <ReferenceInput
      sort={{ field: "name", order: "ASC" }}
      resource="therapeuticCategories"
      label="Categoria Terapêutica"
      source="therapeuticCategories.id"
      reference="opt-in/global/categories"
    >
      <SelectInput
        label="Categoria Terapêutica"
        optionText="name"
        optionValue="id"
      />
    </ReferenceInput>
    <DateInput source="createdAt.gte" label="Assinado a partir de" />
    <DateInput source="createdAt.lte" label="Assinado até" />
    <ReferenceInput
      sort={{ field: "name", order: "ASC" }}
      resource="optType"
      label="Origem de Optin"
      source="optType.id"
      reference="optType"
    >
      <SelectInput label="Origem de Optin" optionText="name" optionValue="id" />
    </ReferenceInput>

    <SelectInput
      label="Tipo de Documento"
      source="typeUser.id"
      choices={typeDocumentChoice}
    />
    <TextInput
      label="Documento"
      source="user.document"
      parse={(value) => value.replace(/[^a-zA-Z0-9]/g, "")}
    />
  </Filter>
);

const OptinList = (props) => {
  const { filterValues } = useListController();

  const filters = Object.keys(filterValues);

  const exportDisabled =
    (filters.length === 1 && filterValues.optType?.id === 2) ||
    filters.length === 0;

  return (
    <List
      perPage={25}
      title="Lista de Usuários com Laboratório Autorizados"
      exporter={exporter}
      filters={<OptinFilter />}
      sort={{ field: "createdAt", order: "DESC" }}
      pagination={<ListPagination />}
      actions={
        <CustomActions
          bulkActions={<OptInUserButtons />}
          disableExport={exportDisabled}
        />
      }
      {...props}
    >
      <Datagrid>
        <TextField sortable={false} label="Nome" source="name" />
        <TextField sortable={false} label="Sobrenome" source="lastName" />
        <TextField sortable={false} label="Documento" source="document" />
        <TextField
          sortable={false}
          label="Tipo de Documento"
          source="typeUser.name"
        />
        <DateField
          label="Data de aceite"
          source="createdAt"
          options={{ timeZone: "UTC" }}
        />
        <TextField
          sortable={false}
          label="Origem Optin"
          source="optinOrigin.name"
        />
        <ArrayField sortable={false} label="Laboratórios" source="sampleLabs">
          <SingleFieldList>
            <ChipField source="name" />
          </SingleFieldList>
          <FunctionField
            render={(record) =>
              record.labsLength > 2 && (
                <h5 style={textStyle}>+{record.labsLength - 2} Laboratórios</h5>
              )
            }
          />
        </ArrayField>
        <ArrayField
          sortable={false}
          label="Categorias Terapêuticas"
          source="sampleTherapeuticCategories"
        >
          <SingleFieldList>
            <ChipField source="name" />
          </SingleFieldList>
          <FunctionField
            render={(record) =>
              record.categoriesLength > 2 && (
                <h5 style={textStyle}>
                  +{record.categoriesLength - 2} Categorias
                </h5>
              )
            }
          />
        </ArrayField>
      </Datagrid>
    </List>
  );
};

export default OptinList;
